import { ExternalPONumberingToggleCard } from '@webapp/modules/purchasing/features/set-external-po-numbering/views/ExternalPONumberingToggleCard'
import { useExternalPONumberingTogglePresenter } from './useExternalPONumberingTogglePresenter'

export interface IExternalPONumberingTogglePresenterProps {
  /** Current saved value, bridged by the Feature Set from the query feature */
  isEnabled: boolean
}

export const ExternalPONumberingTogglePresenter = ({
  isEnabled,
}: IExternalPONumberingTogglePresenterProps) => {
  const {
    states: { value, isSaving },
    methods: { onToggle },
  } = useExternalPONumberingTogglePresenter({ isEnabled })

  return (
    <ExternalPONumberingToggleCard
      isEnabled={value}
      onToggle={onToggle}
      isSaving={isSaving}
    />
  )
}

ExternalPONumberingTogglePresenter.displayName =
  'ExternalPONumberingTogglePresenter'
